import React from 'react';
import { motion } from 'framer-motion';

const Hero = () => {
  return (
    <section className="relative overflow-hidden px-6 py-16 lg:px-8 lg:py-24">
      <div className="mx-auto max-w-7xl">
        <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
          <motion.div 
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            className="order-2 lg:order-1"
          >
            <motion.span 
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="mb-4 block text-xs font-medium uppercase tracking-[0.3em] text-lotus-deep/80"
            >
              Founder & CEO — Preeti Biswas
            </motion.span>

            <motion.h1 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.3, ease: [0.16, 1, 0.3, 1] }}
              className="font-serif text-4xl leading-[1.1] text-lotus-ink sm:text-5xl lg:text-6xl xl:text-7xl"
            >
              Transforming lives,{' '}
              <span className="italic text-lotus-deep/80 font-normal">empowering</span>{' '}
              workplaces.
            </motion.h1>

            <motion.p 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              className="mt-6 max-w-md text-lg leading-relaxed text-lotus-ink/70"
            >
              A journey toward individual well-being through Pranic Healing, guided meditation, and transformative wellness programs.
            </motion.p>

            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.5 }}
              className="mt-8 flex flex-wrap items-center gap-6"
            >
              <motion.a
                whileHover={{ scale: 1.04, y: -2 }}
                whileTap={{ scale: 0.95 }}
                href="#services"
                className="rounded-full bg-lotus-deep px-8 py-4 text-sm font-medium tracking-wide text-white transition-all shadow-md hover:bg-lotus-deep/90 hover:shadow-xl active:scale-95"
              >
                Explore Our Services
              </motion.a>
              <span className="font-serif text-sm italic text-lotus-deep/70">
                Pranic Healing & Meditation
              </span>
            </motion.div>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.3, ease: [0.16, 1, 0.3, 1] }}
            className="relative order-1 lg:order-2"
          >
            <div className="aspect-[4/5] w-full overflow-hidden rounded-3xl bg-lotus-petal/30 outline outline-1 -outline-offset-1 outline-lotus-ink/5 shadow-2xl group">
              <img
                src="/images/lotus-hero.jpg"
                alt="A blooming white lotus flower in soft dawn light"
                className="h-full w-full object-cover transition-transform duration-1000 group-hover:scale-105"
              />
            </div>

            {/* Floating Quote Box with subtle breathing animation */}
            <motion.div 
              animate={{ y: [0, -6, 0] }}
              transition={{ repeat: Infinity, duration: 6, ease: 'easeInOut' }}
              className="absolute -bottom-6 left-4 right-4 sm:left-auto sm:right-auto sm:-left-6 sm:max-w-xs rounded-2xl border border-lotus-petal bg-white p-6 shadow-2xl lg:-bottom-8 lg:-left-8 lg:p-7 z-20"
            >
              <p className="font-serif text-sm sm:text-base italic leading-relaxed text-lotus-ink font-medium">
                "When individuals heal, families become stronger, workplaces become healthier, and communities flourish."
              </p>
              <p className="mt-3 text-xs uppercase tracking-wider text-lotus-deep font-bold">
                — Preeti Biswas, Founder
              </p>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
